import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62f27b64"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  ref: "dataSourceLegend",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Data Source Legend")
const _hoisted_5 = { class: "source-legend-text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-outline-secondary",
  "data-bs-dismiss": "modal"
}, "Close", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalHeader = _resolveComponent("ModalHeader")!
  const _component_ModalBody = _resolveComponent("ModalBody")!
  const _component_ModalFooter = _resolveComponent("ModalFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ModalHeader, null, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_ModalBody, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chunked, (items) => {
              return (_openBlock(), _createElementBlock("div", {
                key: items.name,
                class: "columns",
                style: _normalizeStyle([_ctx.getStyleForDiv()])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.name,
                    class: "column"
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass([_ctx.getClassForPill(item.initials)])
                    }, null, 2),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(item.name) + " (" + _toDisplayString(item.initials.toUpperCase()) + ")", 1)
                  ]))
                }), 128))
              ], 4))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_ModalFooter, null, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ])
    ])
  ], 512))
}